/**
 * Helpers de verificação de direitos do usuário.
 *
 * Substitui o padrão repetido `userRights.includes('X') || userRights?.includes('all')`
 * por uma chamada consolidada que:
 *   - É defensiva contra `userRights` virar `undefined`/`null` (não lança TypeError)
 *   - Encapsula a regra "se tem `all`, tem tudo" num único lugar
 *   - É testável isoladamente (sem componente React)
 *
 * Origem: TD-015 — múltiplos sites em TopMenu/SideMenu/Auth/Screens
 * faziam `userRights.includes(...)` sem optional chaining, com risco
 * de quebrar a tela inteira se o reducer entregasse undefined.
 */

export const hasRight = (userRights, right) => {
	if (!Array.isArray(userRights)) return false;
	return userRights.includes(right) || userRights.includes("all");
};

export const hasAnyRight = (userRights, ...rights) => {
	if (!Array.isArray(userRights)) return false;
	if (userRights.includes("all")) return true;
	return rights.some((r) => userRights.includes(r));
};

export const hasAllRights = (userRights) => {
	if (!Array.isArray(userRights)) return false;
	return userRights.includes("all");
};
